var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder30X30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,0H2H0v2v26v2h2h26h2v-2V2V0H28z M2,3l12,12L2,27V4V3z M3,2h24L15,14L3,2z M15,16l12,12H3L15,16z M16,15L28,3v24L16,15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder30X30);
export default __webpack_public_path__ + "static/media/_placeholder-30x30.7593cbcbdc0e38ebabe5a5d4b242d0a5.svg";
export { ForwardRef as ReactComponent };